// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan-field-row[data-v-90844940] {\n  font-size: 1em;\n}", ""]);
// Exports
module.exports = exports;
